/* KAI RS - kupon DOBRODOSLI v kosarici.
   Gumbi so <span role="button">, ker tema svoje sloge vsiljuje vsakemu <button>. */
(function () {
  'use strict';

  var ROOT = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';

  var CODE = 'DOBRODOSLI';
  var T_OFFER = 'Iskoristi kod <b>' + CODE + '</b>';
  var T_OFFER_SUB = '5% popusta na celu porudžbinu';
  var T_GO = 'Iskoristi';
  var T_ON = '<b>' + CODE + '</b> je aktiviran';
  var T_ON_SUB = 'Ušteda ';
  var T_OFF = 'Ukloni';

  var URL_CART = ROOT + 'cart.js';
  var URL_UPDATE = ROOT + 'cart/update.js';
  var URL_SECTION = ROOT + '?section_id=api-cart-items';
  var URL_DISCOUNT = ROOT + 'discount/';

  var ICON_TAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 3h7l11 11-7 7L3 10V3z"></path><circle cx="7.5" cy="7.5" r="1.2"></circle></svg>';
  var ICON_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>';

  var rendering = false;
  var busy = false;

  function money(cents) {
    var major = (parseInt(cents, 10) || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(major) + ' RSD';
    } catch (e) {
      return major.toFixed(2) + ' RSD';
    }
  }

  function getCart() {
    return fetch(URL_CART, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function strip(active, saved) {
    var el = document.createElement('div');
    el.className = 'kai-cpn' + (active ? ' kai-cpn--on' : '');
    el.setAttribute('data-kai-cpn', '');
    if (active) {
      el.innerHTML =
        '<span class="kai-cpn-ic">' + ICON_OK + '</span>' +
        '<span class="kai-cpn-tx"><span class="kai-cpn-t1">' + T_ON + '</span>' +
        '<span class="kai-cpn-t2">' + T_ON_SUB + saved + '</span></span>' +
        '<span class="kai-cpn-off" role="button" tabindex="0" data-kai-cpn-off>' + T_OFF + '</span>';
    } else {
      el.innerHTML =
        '<span class="kai-cpn-ic">' + ICON_TAG + '</span>' +
        '<span class="kai-cpn-tx"><span class="kai-cpn-t1">' + T_OFFER + '</span>' +
        '<span class="kai-cpn-t2">' + T_OFFER_SUB + '</span></span>' +
        '<span class="kai-cpn-go" role="button" tabindex="0" data-kai-cpn-on>' + T_GO + '</span>';
    }
    return el;
  }

  function savedAmount(cart) {
    var cartLevel = 0;
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if (String(d.title || '').toUpperCase() === CODE) cartLevel += (d.total_allocated_amount || 0);
    });
    if (cartLevel > 0) return cartLevel;
    var lineLevel = 0;
    (cart.items || []).forEach(function (i) {
      (i.discounts || []).forEach(function (d) {
        if (String(d.title || '').toUpperCase() === CODE) lineLevel += (d.amount || 0);
      });
    });
    return lineLevel;
  }

  function clear() {
    var old = document.querySelectorAll('[data-kai-cpn]');
    for (var i = 0; i < old.length; i++) {
      if (old[i].parentNode) old[i].parentNode.removeChild(old[i]);
    }
  }

  function syncTotal(cart) {
    var nodes = document.querySelectorAll('[data-cart-total-price]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = money(cart.total_price);
  }

  function render() {
    if (rendering) return Promise.resolve();
    rendering = true;
    return getCart().then(function (cart) {
      clear();
      if (!cart || !cart.item_count) return;
      syncTotal(cart);

      var codes = cart.discount_codes || [];
      var mine = null, other = null;
      codes.forEach(function (x) {
        var c = String(x.code || '').toUpperCase();
        if (c === CODE) mine = x;
        else if (x.applicable) other = x;
      });
      if (other) return;

      var active = !!(mine && mine.applicable);
      var saved = active ? money(savedAmount(cart)) : '';

      var btns = document.querySelectorAll('button[name="checkout"]');
      for (var i = 0; i < btns.length; i++) {
        if (btns[i].parentNode) btns[i].parentNode.insertBefore(strip(active, saved), btns[i]);
      }
    }).catch(function (e) {
      console.error('KAI kupon:', e);
    }).then(function () {
      setTimeout(function () { rendering = false; }, 60);
    });
  }

  function refreshCartUI() {
    var d = document.querySelector('#cart-drawer');
    var holder = d && d.querySelector('[data-items-holder]');
    if (!d || !holder) { window.location.reload(); return Promise.resolve(); }
    return fetch(URL_SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var doc = new DOMParser().parseFromString(txt, 'text/html');
        var lines = doc.querySelector('[data-api-line-items]');
        var price = doc.querySelector('[data-api-cart-price]');
        var priceHolder = d.querySelector('[data-cart-price-holder]');
        holder.innerHTML = lines ? lines.innerHTML : '';
        if (priceHolder && price) priceHolder.innerHTML = price.innerHTML;
      })
      .catch(function (e) { console.error('KAI kupon refresh:', e); });
  }

  function waitForCode(want, tries) {
    tries = tries || 6;
    return getCart().then(function (cart) {
      var has = (cart.discount_codes || []).some(function (x) {
        return String(x.code || '').toUpperCase() === CODE && x.applicable;
      });
      if (has === want || tries <= 1) return cart;
      return new Promise(function (res) { setTimeout(res, 350); }).then(function () {
        return waitForCode(want, tries - 1);
      });
    });
  }

  function act(on, off) {
    if (busy) return;
    busy = true;
    var host = (on || off).closest('.kai-cpn');
    if (host) host.classList.add('is-busy');

    var step = on
      ? fetch(URL_DISCOUNT + encodeURIComponent(CODE), { credentials: 'same-origin' })
      : fetch(URL_UPDATE, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ discount: '' })
        });

    step.then(function () { return waitForCode(!!on); })
      .then(function () { return refreshCartUI(); })
      .then(function () { return render(); })
      .catch(function (err) { console.error('KAI kupon:', err); })
      .then(function () { busy = false; });
  }

  function handler(e) {
    if (!e.target || !e.target.closest) return;
    var on = e.target.closest('[data-kai-cpn-on]');
    var off = e.target.closest('[data-kai-cpn-off]');
    if (!on && !off) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    e.stopPropagation();
    act(on, off);
  }

  document.addEventListener('click', handler, true);
  document.addEventListener('keydown', handler, true);

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      if (document.querySelector('button[name="checkout"]') && !document.querySelector('[data-kai-cpn]')) render();
    }, 180);
  }

  function boot() {
    render();
    try {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    document.addEventListener('click', function () { setTimeout(schedule, 500); }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
